<!-- list-main-wrap-header-->
<div class="list-main-wrap-header fl-wrap anim_clw " [ngClass]="toggleClass ? 'hidsb_act' : ''">
    <div class="container">
        <!-- list-main-wrap-title-->
        <div class="list-main-wrap-title">
            <h2>Results For : <span>Business List </span></h2>
        </div>
        <!-- list-main-wrap-title end-->
        <!-- list-main-wrap-opt-->
        <div class="list-main-wrap-opt">
            <!-- price-opt-->  
            <div class="price-opt" *ngIf="totalCount">
                <span class="price-opt-title">Sort by:</span>
                <div class="listsearch-input-item ">
                    <select class="form-select" id="sort-by" (change)="sortBy($event)" style="height: 40px; line-height: 28px;">
                        <option value="" selected disabled hidden>Sort By</option>
                        <option value="asc">Sort A-Z</option>
                        <option value="desc">Sort Z-A</option>
                        <option value="category">Sort by Category </option>
                        <option value="country">Sort by Country </option>
                      </select>
                </div>
            </div> 
            <!-- price-opt end-->
            <!-- price-opt-->
            <div class="grid-opt">
                <ul class="no-list-style">
                    <li class="grid-opt_act" [ngClass]="showHideClass ? 'hide' : ''"><span class="two-col-grid tolt" (click)="clickListEvent()" data-microtip-position="bottom" data-tooltip="Grid View"><i class="fal fa-th"></i></span></li>
                    <li class="grid-opt_act" [ngClass]="showHideClass ? '' : 'hide'"><span class="one-col-grid tolt" (click)="clickListEvent()" data-microtip-position="bottom" data-tooltip="List View"><i class="fal fa-list"></i></span></li>
                </ul>
            </div>
            <!-- price-opt end-->
            <div class="show-hidden-sb shsb_btn" (click)="filterEvent()" [ngClass]="toggleClass ? '' : 'shsb_btn_act'"><i class="fal fa-sliders-h"></i> <span>Show Filters</span></div>
        </div>
        <!-- list-main-wrap-opt end-->
    </div>
    <a class="custom-scroll-link back-to-filters clbtg" href="#lisfw"><i class="fas fa-caret-up"></i></a>
</div>
<!-- list-main-wrap-header end-->
<div class="clearfix"></div>
<div class="container">
    <div class="mob-nav-content-btn mncb_half color2-bg shsb_btn shsb_btn_act fl-wrap" (click)="filterEvent()" [ngClass]="toggleClass ? '' : 'shsb_btn_act'"><i class="fal fa-filter"></i> Filters</div>
    <div class="mob-nav-content-btn mncb_half color2-bg schm  fl-wrap" (click)="filterEvent()"><i class="fal fa-map-marker-alt"></i> View on map</div>
</div>
<div class="clearfix"></div>

<div class="close_sbfilters" (click)="filterEvent()" [ngClass]="toggleClass ? '' : 'd-none'"><i class="fal fa-long-arrow-right"></i></div>
<!-- listing-item-container -->
<div class="listing-item-container init-grid-items fl-wrap" id="lisfw">
    <div class="container">
        <!-- listing-item  -->
        <div [ngClass]="showHideClass ? 'has_one_column' : ''" class="listing-item has_two_column" *ngFor="let business of filteredBusiness |  paginate: {itemsPerPage: itemsPerPage, currentPage: pagination, totalItems: totalCount};  let i = index;">
            <app-business-card [businessData]="business"></app-business-card>
        </div>
        
        <!-- listing-item end --> 
        <div class="pagination fwmpag" *ngIf="totalCount">
            <pagination-controls (pageChange)="renderPage($event)"> </pagination-controls>
        </div>
    </div>
</div>
<!-- listing-item-container end -->
 
<div class="clearfix"></div>
<div class="alert alert-danger p-2 m-5" *ngIf="!totalCount">
    No record found.
</div> 